import React from 'react'

const faqItems = [
  {
    q: 'How do I verify my school profile?',
    a: 'Complete your school profile with all required information including verified school badge, lead trainer bio, curriculum link, and at least 8 studio photos. Once submitted, our team will review and verify within 1-2 business days.',
  },
  {
    q: 'Can I list multiple programs or certifications?',
    a: 'Yes! You can list as many teacher training programs as you offer. Each program can have its own dates, pricing, accommodation options, and curriculum. Use the Courses section in your dashboard to add new listings.',
  },
  {
    q: 'When do I receive payment for students?',
    a: 'You set a full course fee and a booking amount (upfront payment) for each room. Bookmyyogattc charges 10% commission on the total course fee, deducted from the booking amount paid online. The booking amount must be more than 10% of the course fee so it can cover that commission. You receive the booking amount minus the commission; the student pays the remaining balance directly to your school on arrival.',
  },
  {
    q: 'How do I update my course dates or pricing?',
    a: 'Go to Courses in your dashboard, select the course you want to edit, and update the details. Changes are reflected immediately for new bookings. Existing bookings retain their original terms.',
  },
  {
    q: 'What if I need help with my listing?',
    a: 'Our support team is available Monday–Friday, 9am–6pm. Use the Contact Support button below or email info@bookmyyogattc.com.',
  },
]

const FAQ: React.FC = () => (
  <div className="max-w-4xl mx-auto px-8 py-10">
    <nav className="mb-6">
      <ol className="flex items-center gap-2 text-sm text-gray-500">
        <li>Docs</li>
        <li>/</li>
        <li className="text-gray-900 font-medium">FAQ</li>
      </ol>
    </nav>

    <h1 className="text-3xl font-bold text-gray-900 mb-4">
      Frequently Asked <span className="text-primary-500">Questions</span>
    </h1>
    <p className="text-gray-600 mb-12 leading-relaxed">
      Find answers to common questions about listing your school, managing bookings, and payments.
    </p>

    <div className="space-y-4">
      {faqItems.map((faq, i) => (
        <div key={i} className="bg-white border border-gray-200 rounded-xl p-6 hover:border-emerald-200 transition-colors">
          <h3 className="font-semibold text-gray-900 mb-2">{faq.q}</h3>
          <p className="text-sm text-gray-600 leading-relaxed">{faq.a}</p>
        </div>
      ))}
    </div>
  </div>
)

export default FAQ
